var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotIconRedOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 5.467c-.289.321-.773.845-1.452 1.573l.557 2.755",
    stroke: "#EF6461",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.238 1.967c1.21 0 2.19.954 2.19 2.13 0 1.177-.98 2.131-2.19 2.131s-2.19-.954-2.19-2.13c0-1.177.98-2.131 2.19-2.131zm0 1.065c-.605 0-1.095.477-1.095 1.065 0 .589.49 1.066 1.095 1.066s1.095-.477 1.095-1.066c0-.588-.49-1.065-1.095-1.065z",
    fill: "#EF6461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.613 10.192a9.358 9.358 0 0 1 6.638 2.75A9.358 9.358 0 0 1 26 19.58v7.211c0 .601-.243 1.145-.637 1.539a2.168 2.168 0 0 1-1.538.637H7.175c-.6 0-1.144-.244-1.538-.637A2.168 2.168 0 0 1 5 26.79V19.58a9.358 9.358 0 0 1 2.75-6.638 9.358 9.358 0 0 1 6.637-2.75z",
    stroke: "#EF6461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.362 13.805c1.664 0 3.271.384 4.71 1.107a.795.795 0 0 1 .353 1.07.803.803 0 0 1-1.076.352 8.854 8.854 0 0 0-3.987-.935c-1.47 0-2.882.351-4.133 1.011a.803.803 0 0 1-1.083-.33.795.795 0 0 1 .333-1.078 10.452 10.452 0 0 1 4.883-1.197z",
    fill: "#EF6461",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.553 17.418a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 2a2.5 2.5 0 1 0 2.126 1.185 1 1 0 1 1-1.636-1.137 2.512 2.512 0 0 0-.49-.048z",
    fill: "#EF6461"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotIconRedOutlined);
export default __webpack_public_path__ + "static/media/botIconRedOutlined.54cf5320c586f2ac196b012e6e1d8621.svg";
export { ForwardRef as ReactComponent };